module.exports = __webpack_public_path__ + "img/portfolio1.1ea68b39.jpg";